define('adminEmailAddressesEditPopupView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'jquery',
  'marionette',
  'bootbox',
  'template!adminEmailAddressesEditPopupView',
  'entities/admin/email_addresses'
], function (
  App,
  Module,
  Backbone,
  _,
  $,
  Marionette,
  Bootbox,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'admin-email-addresses-popup-edit-view',

    ui: {
      searchInput: '.search-input',
      suggestions: '.suggestions',
      membersList: '.members-list',
      closeButton: '.btn-close'
    },

    events: {
      'input @ui.searchInput': 'onSearch',
      'click .suggestion': 'onPickSuggestion',
      'click .members-list .remove': 'onRemoveMember',
      'click @ui.closeButton': 'onClose'
    },

    initialize: function () {
      this.emailSecId = this.options.emailSecId;
      this.canEdit = this.options.canEdit === true;
      this.emailData = null;
      this.searchTimer = null;
    },

    onShow: function () {
      this.loadEmail();
    },

    loadEmail: function () {
      App.request('emailAddresses:get', this.emailSecId).done(_.bind(function (data) {
        this.emailData = data;
        this.render();
      }, this));
    },

    serializeData: function () {
      return {
        canEdit: this.canEdit,
        email: this.emailData ? this.emailData.email : '',
        nameFrom: this.emailData ? this.emailData.nameFrom : '',
        members: (this.emailData && this.emailData.members) || [],
        placeholder: _.i18n('admin.emailAddresses.searchUserPlaceholder')
      };
    },

    onSearch: function () {
      if (!this.canEdit) return;
      var query = this.ui.searchInput.val();
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(_.bind(function () {
        if (!query || query.length < 1) {
          this.ui.suggestions.empty().hide();
          return;
        }
        App.request('emailAddresses:search-userpids', query).done(_.bind(function (users) {
          this.renderSuggestions(users || []);
        }, this));
      }, this), 250);
    },

    renderSuggestions: function (users) {
      var currentIds = _.pluck((this.emailData && this.emailData.members) || [], 'secId');
      var filtered = _.filter(users, function (u) {
        return !_.contains(currentIds, u.secId);
      });
      var html = _.map(filtered, function (u) {
        var label = _.escape((u.firstName || '') + ' ' + (u.lastName || '') + ' <' + (u.email || '') + '>');
        return '<div class="suggestion" data-sec-id="' + _.escape(u.secId) + '">' + label + '</div>';
      }).join('');
      this.ui.suggestions.html(html).show();
    },

    onPickSuggestion: function (e) {
      if (!this.canEdit) return;
      var secId = $(e.currentTarget).data('sec-id');
      App.request('emailAddresses:add-member', this.emailSecId, secId).done(_.bind(function () {
        this.ui.searchInput.val('');
        this.ui.suggestions.empty().hide();
        this.loadEmail();
        if (this.options.onConfirm) this.options.onConfirm();
      }, this)).fail(function (xhr) {
        var msg = (xhr && xhr.status === 403) ?
          _.i18n('admin.emailAddresses.forbidden') :
          _.i18n('common.error');
        Bootbox.alert(msg);
      });
    },

    onRemoveMember: function (e) {
      if (!this.canEdit) return;
      var secId = $(e.currentTarget).data('sec-id');
      App.request('emailAddresses:remove-member', this.emailSecId, secId).done(_.bind(function () {
        this.loadEmail();
        if (this.options.onConfirm) this.options.onConfirm();
      }, this)).fail(function (xhr) {
        var msg = (xhr && xhr.status === 403) ?
          _.i18n('admin.emailAddresses.forbidden') :
          _.i18n('common.error');
        Bootbox.alert(msg);
      });
    },

    onClose: function () {
      this.windowView.close();
    }
  });
});

